// Recovered compiled webpack factory 44648. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n;
  r.d(t, { TsN: () => tE });
  var a = r(49636),
    o = r(43275),
    i = r(81259);
  function s(e, t, r = [t], n = "npm") {
    let a = ((e._metadata = e._metadata || {}).sdk = e._metadata.sdk || {});
    a.name ||
      ((a.name = `sentry.javascript.${t}`),
      (a.packages = r.map((e) => ({ name: `${n}:@sentry/${e}`, version: i.M }))),
      (a.version = i.M));
  }
  var l = r(27122),
    u = r(61571);
  let c = [];
  function f(e, t) {
    for (let r of t) r?.afterAllSetup && r.afterAllSetup(e);
  }
  function d(e, t, r) {
    if (r[t.name]) {
      u.T && o.Yz.log(`Integration skipped because it was already installed: ${t.name}`);
      return;
    }
    if (
      ((r[t.name] = t),
      c.includes(t.name) || "function" != typeof t.setupOnce || (t.setupOnce(), c.push(t.name)),
      t.setup && "function" == typeof t.setup && t.setup(e),
      "function" == typeof t.preprocessEvent)
    ) {
      let r = t.preprocessEvent.bind(t);
      e.on("preprocessEvent", (t, n) => r(t, n, e));
    }
    if ("function" == typeof t.processEvent) {
      let r = t.processEvent.bind(t),
        n = Object.assign((t, n) => r(t, n, e), { id: t.name });
      e.addEventProcessor(n);
    }
    u.T && o.Yz.log(`Integration installed: ${t.name}`);
  }
  function p(e) {
    let t = [];
    e.message && t.push(e.message);
    try {
      let r = e.exception.values[e.exception.values.length - 1];
      r?.value && (t.push(r.value), r.type && t.push(`${r.type}: ${r.value}`));
    } catch {}
    return t;
  }
  var h = r(28385),
    _ = r(35868);
  let m = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    /can't redefine non-configurable property "solana"/,
    /vv\(\)\.getRestrictions is not a function/,
    /Can't find variable: _AutofillCallbackHandler/,
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    /^Java exception was raised during method invocation$/,
  ];
  function g(e = {}, t = {}) {
    return {
      allowUrls: [...(e.allowUrls || []), ...(t.allowUrls || [])],
      denyUrls: [...(e.denyUrls || []), ...(t.denyUrls || [])],
      ignoreErrors: [
        ...(e.ignoreErrors || []),
        ...(t.ignoreErrors || []),
        ...(e.disableErrorDefaults ? [] : m),
      ],
      ignoreTransactions: [...(e.ignoreTransactions || []), ...(t.ignoreTransactions || [])],
    };
  }
  function y(e) {
    try {
      let t = [...(e.exception?.values ?? [])]
          .reverse()
          .find((e) => e.mechanism?.parent_id === void 0 && e.stacktrace?.frames?.length),
        r = t?.stacktrace?.frames;
      return r
        ? (function (e = []) {
            for (let t = e.length - 1; t >= 0; t--) {
              let r = e[t];
              if (r && "<anonymous>" !== r.filename && "[native code]" !== r.filename)
                return r.filename || null;
            }
            return null;
          })(r)
        : null;
    } catch {
      return (u.T && o.Yz.error(`Cannot extract url for event ${(0, h.$X)(e)}`), null);
    }
  }
  var v = r(2257),
    b = r(73314);
  let E = new WeakMap();
  var R = r(88722),
    P = r(85236);
  function S(e, t) {
    let r = (0, P.RV)(e),
      n = (0, P.RV)(t);
    if (!r && !n) return !0;
    if ((r && !n) || (!r && n) || n.length !== r.length) return !1;
    for (let e = 0; e < n.length; e++) {
      let t = n[e],
        a = r[e];
      if (
        t.filename !== a.filename ||
        t.lineno !== a.lineno ||
        t.colno !== a.colno ||
        t.function !== a.function
      )
        return !1;
    }
    return !0;
  }
  function O(e, t) {
    let r = e.fingerprint,
      n = t.fingerprint;
    if (!r && !n) return !0;
    if ((r && !n) || (!r && n)) return !1;
    try {
      return r.join("") === n.join("");
    } catch {
      return !1;
    }
  }
  function T(e) {
    return e.exception?.values?.[0];
  }
  var w = r(26552),
    j = r(27123),
    x = r(60057),
    A = r(22758),
    C = r(31209);
  function M(e, t) {
    var r;
    let n = t ?? ((r = e), N().get(r)) ?? [];
    if (0 === n.length) return;
    let a = e.getOptions(),
      o = (function (e, t, r, n) {
        let a = {};
        return (
          t?.sdk && (a.sdk = { name: t.sdk.name, version: t.sdk.version }),
          r && n && (a.dsn = (0, A.SB)(n)),
          (0, C.h4)(a, [
            [
              {
                type: "log",
                item_count: e.length,
                content_type: "application/vnd.sentry.items.log+json",
              },
              { items: e },
            ],
          ])
        );
      })(n, a._metadata, a.tunnel, e.getDsn());
    (N().set(e, []), e.emit("flushLogs"), e.sendEnvelope(o));
  }
  function N() {
    return (0, x.BY)("clientToLogBufferMap", () => new WeakMap());
  }
  function k(e, t) {
    var r;
    let n = t ?? ((r = e), I().get(r)) ?? [];
    if (0 === n.length) return;
    let a = e.getOptions(),
      o = (function (e, t, r, n) {
        let a = {};
        return (
          t?.sdk && (a.sdk = { name: t.sdk.name, version: t.sdk.version }),
          r && n && (a.dsn = (0, A.SB)(n)),
          (0, C.h4)(a, [
            [
              {
                type: "trace_metric",
                item_count: e.length,
                content_type: "application/vnd.sentry.items.trace-metric+json",
              },
              { items: e },
            ],
          ])
        );
      })(n, a._metadata, a.tunnel, e.getDsn());
    (I().set(e, []), e.emit("flushMetrics"), e.sendEnvelope(o));
  }
  function I() {
    return (0, x.BY)("clientToMetricBufferMap", () => new WeakMap());
  }
  var L = r(24617),
    D = r(89135),
    U = r(43115);
  function H(e) {
    return ("object" == typeof e && "function" == typeof e.unref && e.unref(), e);
  }
  let F = Symbol.for("SentryBufferFullError");
  function $(e = 100) {
    let t = new Set();
    return {
      get $() {
        return Array.from(t);
      },
      add: function (r) {
        if (!(t.size < e)) return (0, U.xg)(F);
        let n = r();
        return (
          t.add(n),
          n.then(
            () => {
              t.delete(n);
            },
            () => {
              t.delete(n);
            },
          ),
          n
        );
      },
      drain: function (e) {
        if (!t.size) return (0, U.XW)(!0);
        let r = Promise.allSettled(Array.from(t)).then(() => !0);
        return e ? Promise.race([r, new Promise((t) => H(setTimeout(() => t(!1), e)))]) : r;
      },
    };
  }
  var B = r(42106),
    z = r(87624),
    q = r(16649),
    Y = r(76871),
    X = r(40364),
    W = r(71350),
    K = r(78714),
    G = r(47434),
    V = r(51290);
  let J = "Not capturing exception because it's already been captured.",
    Q = "Discarded session because of missing or non-string release",
    Z = Symbol.for("SentryInternalError"),
    ee = Symbol.for("SentryDoNotSendEventError");
  function et(e) {
    return { message: e, [Z]: !0 };
  }
  function er(e) {
    return { message: e, [ee]: !0 };
  }
  function en(e) {
    return !!e && "object" == typeof e && Z in e;
  }
  function ea(e) {
    return !!e && "object" == typeof e && ee in e;
  }
  function eo(e, t, r, n, a) {
    let o,
      i = 0,
      s = !1;
    (e.on(r, () => {
      ((i = 0), clearTimeout(o), (s = !1));
    }),
      e.on(t, (t) => {
        (i += n(t)) >= 8e5
          ? a(e)
          : s ||
            ((s = !0),
            (o = H(
              setTimeout(() => {
                a(e);
              }, 5e3),
            )));
      }),
      e.on("flush", () => {
        a(e);
      }));
  }
  class ei {
    constructor(e) {
      if (
        ((this._options = e),
        (this._integrations = {}),
        (this._numProcessing = 0),
        (this._outcomes = {}),
        (this._hooks = {}),
        (this._eventProcessors = []),
        (this._promiseBuffer = $(e.transportOptions?.bufferSize ?? 64)),
        e.dsn
          ? (this._dsn = (0, A.AD)(e.dsn))
          : u.T && o.Yz.warn("No DSN provided, client will not send events."),
        this._dsn)
      ) {
        let t = (function (e, t, r) {
          return (
            t ||
            `${(function (e) {
              let t = e.protocol ? `${e.protocol}:` : "",
                r = e.port ? `:${e.port}` : "";
              return `${t}//${e.host}${r}${e.path ? `/${e.path}` : ""}/api/`;
            })(e)}${e.projectId}/envelope/?${(function (e, t) {
              let r = { sentry_version: "7" };
              return (
                e.publicKey && (r.sentry_key = e.publicKey),
                t && (r.sentry_client = `${t.name}/${t.version}`),
                new URLSearchParams(r).toString()
              );
            })(e, r)}`
          );
        })(this._dsn, e.tunnel, e._metadata ? e._metadata.sdk : void 0);
        this._transport = e.transport({
          tunnel: this._options.tunnel,
          recordDroppedEvent: this.recordDroppedEvent.bind(this),
          ...e.transportOptions,
          url: t,
        });
      }
      ((this._options.enableLogs =
        this._options.enableLogs ?? this._options._experiments?.enableLogs),
        this._options.enableLogs && eo(this, "afterCaptureLog", "flushLogs", ef, M),
        (this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? !0) &&
          eo(this, "afterCaptureMetric", "flushMetrics", ec, k));
    }
    captureException(e, t, r) {
      let n = (0, h.eJ)();
      if ((0, h.GR)(e)) return (u.T && o.Yz.log(J), n);
      let a = { event_id: n, ...t };
      return (
        this._process(
          () =>
            this.eventFromException(e, a)
              .then((e) => this._captureEvent(e, a, r))
              .then((e) => e),
          "error",
        ),
        a.event_id
      );
    }
    captureMessage(e, t, r, n) {
      let a = { event_id: (0, h.eJ)(), ...r },
        o = (0, q.NF)(e) ? e : String(e),
        i = (0, q.sO)(e),
        s = i ? this.eventFromMessage(o, t, a) : this.eventFromException(e, a);
      return (
        this._process(() => s.then((e) => this._captureEvent(e, a, n)), i ? "unknown" : "error"),
        a.event_id
      );
    }
    captureEvent(e, t, r) {
      let n = (0, h.eJ)();
      if (t?.originalException && (0, h.GR)(t.originalException)) return (u.T && o.Yz.log(J), n);
      let a = { event_id: n, ...t },
        i = e.sdkProcessingMetadata || {},
        s = i.capturedSpanScope,
        l = i.capturedSpanIsolationScope,
        c = es(e.type);
      return (this._process(() => this._captureEvent(e, a, s || r, l), c), a.event_id);
    }
    captureSession(e) {
      (this.sendSession(e), (0, L.qO)(e, { init: !1 }));
    }
    getDsn() {
      return this._dsn;
    }
    getOptions() {
      return this._options;
    }
    getSdkMetadata() {
      return this._options._metadata;
    }
    getTransport() {
      return this._transport;
    }
    async flush(e) {
      let t = this._transport;
      if (!t) return !0;
      this.emit("flush");
      let r = await this._isClientDoneProcessing(e),
        n = await t.flush(e);
      return r && n;
    }
    async close(e) {
      M(this);
      let t = await this.flush(e);
      return ((this.getOptions().enabled = !1), this.emit("close"), t);
    }
    getEventProcessors() {
      return this._eventProcessors;
    }
    addEventProcessor(e) {
      this._eventProcessors.push(e);
    }
    init() {
      (this._isEnabled() ||
        this._options.integrations.some(({ name: e }) => e.startsWith("Spotlight"))) &&
        this._setupIntegrations();
    }
    getIntegrationByName(e) {
      return this._integrations[e];
    }
    addIntegration(e) {
      let t = this._integrations[e.name];
      (d(this, e, this._integrations), t || f(this, [e]));
    }
    sendEvent(e, t = {}) {
      this.emit("beforeSendEvent", e, t);
      let r = (0, j.V7)(e, this._dsn, this._options._metadata, this._options.tunnel);
      for (let e of t.attachments || []) r = (0, C.W3)(r, (0, C.bm)(e));
      this.sendEnvelope(r).then((t) => this.emit("afterSendEvent", e, t));
    }
    sendSession(e) {
      let { release: t, environment: r = w.U } = this._options;
      if ("aggregates" in e) {
        let n = e.attrs || {};
        if (!n.release && !t) {
          u.T && o.Yz.warn(Q);
          return;
        }
        ((n.release = n.release || t), (n.environment = n.environment || r), (e.attrs = n));
      } else {
        if (!e.release && !t) {
          u.T && o.Yz.warn(Q);
          return;
        }
        ((e.release = e.release || t), (e.environment = e.environment || r));
      }
      this.emit("beforeSendSession", e);
      let n = (0, j.LE)(e, this._dsn, this._options._metadata, this._options.tunnel);
      this.sendEnvelope(n);
    }
    recordDroppedEvent(e, t, r = 1) {
      if (this._options.sendClientReports) {
        let n = `${e}:${t}`;
        (u.T && o.Yz.log(`Recording outcome: "${n}"${r > 1 ? ` (${r} times)` : ""}`),
          (this._outcomes[n] = (this._outcomes[n] || 0) + r));
      }
    }
    on(e, t) {
      let r = (this._hooks[e] = this._hooks[e] || new Set()),
        n = (...e) => t(...e);
      return (
        r.add(n),
        () => {
          r.delete(n);
        }
      );
    }
    emit(e, ...t) {
      let r = this._hooks[e];
      r && r.forEach((e) => e(...t));
    }
    async sendEnvelope(e) {
      if ((this.emit("beforeEnvelope", e), this._isEnabled() && this._transport))
        try {
          return await this._transport.send(e);
        } catch (e) {
          return (u.T && o.Yz.error("Error while sending envelope:", e), {});
        }
      return (u.T && o.Yz.error("Transport disabled"), {});
    }
    dispose() {}
    _setupIntegrations() {
      let { integrations: e } = this._options;
      ((this._integrations = (function (e, t) {
        let r = {};
        return (
          t.forEach((t) => {
            t && d(e, t, r);
          }),
          r
        );
      })(this, e)),
        f(this, e));
    }
    _updateSessionFromEvent(e, t) {
      let r = "fatal" === t.level,
        n = !1,
        a = t.exception?.values;
      if (a) {
        for (let e of ((n = !0), (r = !1), a))
          if (e.mechanism?.handled === !1) {
            r = !0;
            break;
          }
      }
      let o = "ok" === e.status;
      ((o && 0 === e.errors) || (o && r)) &&
        ((0, L.qO)(e, { ...(r && { status: "crashed" }), errors: e.errors || Number(n || r) }),
        this.captureSession(e));
    }
    async _isClientDoneProcessing(e) {
      let t = 0;
      for (; !e || t < e; ) {
        if ((await new Promise((e) => setTimeout(e, 1)), !this._numProcessing)) return !0;
        t++;
      }
      return !1;
    }
    _isEnabled() {
      return !1 !== this.getOptions().enabled && void 0 !== this._transport;
    }
    _prepareEvent(e, t, r, n) {
      let a = this.getOptions(),
        o = Object.keys(this._integrations);
      return (
        !t.integrations && o?.length && (t.integrations = o),
        this.emit("preprocessEvent", e, t),
        e.type || n.setLastEventId(e.event_id || t.event_id),
        (0, W.mG)(a, e, t, r, this, n).then(
          (e) => (
            null === e ||
              (this.emit("postprocessEvent", e, t),
              (e.contexts = { trace: { ...e.contexts?.trace, ...(0, v.vn)(r) }, ...e.contexts }),
              (e.sdkProcessingMetadata = {
                dynamicSamplingContext: (0, D.ao)(this, r),
                ...e.sdkProcessingMetadata,
              })),
            e
          ),
        )
      );
    }
    _captureEvent(e, t = {}, r = (0, v.o5)(), n = (0, v.rm)()) {
      return (
        u.T && el(e) && o.Yz.log(`Captured error event \`${p(e)[0] || "<unknown>"}\``),
        this._processEvent(e, t, r, n).then(
          (e) => e.event_id,
          (e) => {
            u.T && (ea(e) ? o.Yz.log(e.message) : en(e) ? o.Yz.warn(e.message) : o.Yz.warn(e));
          },
        )
      );
    }
    _processEvent(e, t, r, n) {
      let a = this.getOptions(),
        { sampleRate: o } = a,
        i = eu(e),
        s = el(e),
        l = e.type || "error",
        u = `before send for type \`${l}\``,
        c = void 0 === o ? void 0 : (0, X.i)(o);
      if (s && "number" == typeof c && (0, K.hY)() > c)
        return (
          this.recordDroppedEvent("sample_rate", "error"),
          (0, U.xg)(
            er(
              `Discarding event because it's not included in the random sample (sampling rate = ${o})`,
            ),
          )
        );
      let f = es(e.type);
      return this._prepareEvent(e, t, r, n)
        .then((e) => {
          if (null === e)
            throw (
              this.recordDroppedEvent("event_processor", f),
              er("An event processor returned `null`, will not send event.")
            );
          return t.data?.__sentry__ === !0
            ? e
            : (function (e, t) {
                let r = `${t} must return \`null\` or a valid event.`;
                if ((0, q.Qg)(e))
                  return e.then(
                    (e) => {
                      if (!(0, q.Qd)(e) && null !== e) throw et(r);
                      return e;
                    },
                    (e) => {
                      throw et(`${t} rejected with ${e}`);
                    },
                  );
                if (!(0, q.Qd)(e) && null !== e) throw et(r);
                return e;
              })(
                (function (e, t, r, n) {
                  let {
                      beforeSend: a,
                      beforeSendTransaction: o,
                      beforeSendSpan: i,
                      ignoreSpans: s,
                    } = t,
                    l = r;
                  if (el(l) && a) return a(l, n);
                  if (eu(l)) {
                    if (i || s) {
                      let t = (function (e) {
                        let {
                          trace_id: t,
                          parent_span_id: r,
                          span_id: n,
                          status: a,
                          origin: o,
                          data: i,
                          op: s,
                        } = e.contexts?.trace ?? {};
                        return {
                          data: i ?? {},
                          description: e.transaction,
                          op: s,
                          parent_span_id: r,
                          span_id: n ?? "",
                          start_timestamp: e.start_timestamp ?? 0,
                          status: a,
                          timestamp: e.timestamp,
                          trace_id: t ?? "",
                          origin: o,
                          profile_id: i?.[R.E1],
                          exclusive_time: i?.[R.jG],
                          measurements: e.measurements,
                          is_segment: !0,
                        };
                      })(l);
                      if (s?.length && (0, G.e)(t, s)) return null;
                      if (i) {
                        let e = i(t);
                        if (e)
                          l = (0, Y.h)(r, {
                            type: "transaction",
                            timestamp: e.timestamp,
                            start_timestamp: e.start_timestamp,
                            transaction: e.description,
                            contexts: {
                              trace: {
                                trace_id: e.trace_id,
                                span_id: e.span_id,
                                parent_span_id: e.parent_span_id,
                                op: e.op,
                                status: e.status,
                                origin: e.origin,
                                data: {
                                  ...e.data,
                                  ...(e.profile_id && { [R.E1]: e.profile_id }),
                                  ...(e.exclusive_time && { [R.jG]: e.exclusive_time }),
                                },
                              },
                            },
                            measurements: e.measurements,
                          });
                        else (0, V.xl)();
                      }
                      if (l.spans) {
                        let t = [],
                          r = l.spans;
                        for (let e of r) {
                          if (s?.length && (0, G.e)(e, s)) {
                            (0, G.R)(r, e);
                            continue;
                          }
                          if (i) {
                            let r = i(e);
                            r ? t.push(r) : ((0, V.xl)(), t.push(e));
                          } else t.push(e);
                        }
                        let n = l.spans.length - t.length;
                        (n && e.recordDroppedEvent("before_send", "span", n), (l.spans = t));
                      }
                    }
                    if (o) {
                      if (l.spans) {
                        let e = l.spans.length;
                        l.sdkProcessingMetadata = {
                          ...r.sdkProcessingMetadata,
                          spanCountBeforeProcessing: e,
                        };
                      }
                      return o(l, n);
                    }
                  }
                  return l;
                })(this, a, e, t),
                u,
              );
        })
        .then((a) => {
          if (null === a) {
            if ((this.recordDroppedEvent("before_send", f), i)) {
              let t = 1 + (e.spans || []).length;
              this.recordDroppedEvent("before_send", "span", t);
            }
            throw er(`${u} returned \`null\`, will not send event.`);
          }
          let o = r.getSession() || n.getSession();
          if ((s && o && this._updateSessionFromEvent(o, a), i)) {
            let e =
              (a.sdkProcessingMetadata?.spanCountBeforeProcessing || 0) -
              (a.spans ? a.spans.length : 0);
            e > 0 && this.recordDroppedEvent("before_send", "span", e);
          }
          let l = a.transaction_info;
          return (
            i &&
              l &&
              a.transaction !== e.transaction &&
              (a.transaction_info = { ...l, source: "custom" }),
            this.sendEvent(a, t),
            a
          );
        })
        .then(null, (e) => {
          if (ea(e) || en(e)) throw e;
          throw (
            this.captureException(e, {
              mechanism: { handled: !1, type: "internal" },
              data: { __sentry__: !0 },
              originalException: e,
            }),
            et(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${e}`)
          );
        });
    }
    _process(e, t) {
      (this._numProcessing++,
        this._promiseBuffer.add(e).then(
          (e) => (this._numProcessing--, e),
          (e) => (
            this._numProcessing--,
            e === F && this.recordDroppedEvent("queue_overflow", t),
            e
          ),
        ));
    }
    _clearOutcomes() {
      let e = this._outcomes;
      return (
        (this._outcomes = {}),
        Object.entries(e).map(([e, t]) => {
          let [r, n] = e.split(":");
          return { reason: r, category: n, quantity: t };
        })
      );
    }
    _flushOutcomes() {
      u.T && o.Yz.log("Flushing outcomes...");
      let e = this._clearOutcomes();
      if (0 === e.length) {
        u.T && o.Yz.log("No outcomes to send");
        return;
      }
      if (!this._dsn) {
        u.T && o.Yz.log("No dsn provided, will not send outcomes");
        return;
      }
      u.T && o.Yz.log("Sending outcomes:", e);
      let t = (function (e, t, r) {
        let n = [{ type: "client_report" }, { timestamp: (0, z.lu)(), discarded_events: e }];
        return (0, C.h4)(t ? { dsn: t } : {}, [n]);
      })(e, this._options.tunnel && (0, A.SB)(this._dsn));
      this.sendEnvelope(t);
    }
  }
  function es(e) {
    return "replay_event" === e ? "replay" : e || "error";
  }
  function el(e) {
    return void 0 === e.type;
  }
  function eu(e) {
    return "transaction" === e.type;
  }
  function ec(e) {
    let t = 0;
    return (e.name && (t += 2 * e.name.length), (t += 8) + ed(e.attributes));
  }
  function ef(e) {
    let t = 0;
    return (e.message && (t += 2 * e.message.length), t + ed(e.attributes));
  }
  function ed(e) {
    if (!e) return 0;
    let t = 0;
    return (
      Object.values(e).forEach((e) => {
        Array.isArray(e) ? (t += e.length * ep(e[0])) : (0, q.sO)(e) ? (t += ep(e)) : (t += 100);
      }),
      t
    );
  }
  function ep(e) {
    return "string" == typeof e
      ? 2 * e.length
      : "number" == typeof e
        ? 8
        : 4 * ("boolean" == typeof e);
  }
  var eh = r(14356);
  function e_(e) {
    "aggregates" in e
      ? e.attrs?.ip_address === void 0 && (e.attrs = { ...e.attrs, ip_address: "{{auto}}" })
      : void 0 === e.ipAddress && (e.ipAddress = "{{auto}}");
  }
  var em = r(2332);
  function eg(e) {
    return (0, q.bJ)(e) &&
      "__sentry_fetch_url_host__" in e &&
      "string" == typeof e.__sentry_fetch_url_host__
      ? `${e.message} (${e.__sentry_fetch_url_host__})`
      : e.message;
  }
  function ey(e, t) {
    let r = eb(e, t),
      n = {
        type: (function (e) {
          let t = e?.name;
          return !t && eR(e)
            ? e.message && Array.isArray(e.message) && 2 == e.message.length
              ? e.message[0]
              : "WebAssembly.Exception"
            : t;
        })(t),
        value: (function (e) {
          let t = e?.message;
          return eR(e)
            ? Array.isArray(e.message) && 2 == e.message.length
              ? e.message[1]
              : "wasm exception"
            : t
              ? t.error && "string" == typeof t.error.message
                ? eg(t.error)
                : eg(e)
              : "No error message";
        })(t),
      };
    return (
      r.length && (n.stacktrace = { frames: r }),
      void 0 === n.type && "" === n.value && (n.value = "Unrecoverable error caught"),
      n
    );
  }
  function ev(e, t) {
    return { exception: { values: [ey(e, t)] } };
  }
  function eb(e, t) {
    var r, n;
    let a = t.stacktrace || t.stack || "",
      o = (r = t) && eE.test(r.message) ? 1 : 0,
      i = "number" == typeof (n = t).framesToPop ? n.framesToPop : 0;
    try {
      return e(a, o, i);
    } catch {}
    return [];
  }
  let eE = /Minified React error #\d+;/i;
  function eR(e) {
    return (
      "undefined" != typeof WebAssembly &&
      void 0 !== WebAssembly.Exception &&
      e instanceof WebAssembly.Exception
    );
  }
  function eP(e, t, r, n, a) {
    let o;
    if ((0, q.T2)(t) && t.error) return ev(e, t.error);
    if ((0, q.BD)(t) || (0, q.W6)(t)) {
      if ("stack" in t) o = ev(e, t);
      else {
        let a = t.name || ((0, q.BD)(t) ? "DOMError" : "DOMException"),
          i = t.message ? `${a}: ${t.message}` : a;
        ((o = eS(e, i, r, n)), (0, h.gO)(o, i));
      }
      return ("code" in t && (o.tags = { ...o.tags, "DOMException.code": `${t.code}` }), o);
    }
    return (0, q.bJ)(t)
      ? ev(e, t)
      : ((0, q.Qd)(t) || (0, q.xH)(t)
          ? (o = (function (e, t, r, n) {
              let a = (0, v.KU)(),
                o = a?.getOptions().normalizeDepth,
                i = Object.values(t).find((e) => e instanceof Error),
                s = { __serialized__: (0, em.cd)(t, o) };
              if (i) return { exception: { values: [ey(e, i)] }, extra: s };
              let l = {
                exception: {
                  values: [
                    {
                      type: (0, q.xH)(t) ? t.constructor.name : n ? "UnhandledRejection" : "Error",
                      value: (function (e, { isUnhandledRejection: t }) {
                        let r = (0, b.HF)(e),
                          n = t ? "promise rejection" : "exception";
                        if ((0, q.T2)(e))
                          return `Event \`ErrorEvent\` captured as ${n} with message \`${e.message}\``;
                        if ((0, q.xH)(e)) {
                          let t = (function (e) {
                            try {
                              let t = Object.getPrototypeOf(e);
                              return t ? t.constructor.name : void 0;
                            } catch {}
                          })(e);
                          return `Event \`${t}\` (type=${e.type}) captured as ${n}`;
                        }
                        return `Object captured as ${n} with keys: ${r}`;
                      })(t, { isUnhandledRejection: n }),
                    },
                  ],
                },
                extra: s,
              };
              if (r) {
                let t = eb(e, r);
                t.length && (l.exception.values[0].stacktrace = { frames: t });
              }
              return l;
            })(e, t, r, a))
          : ((o = eS(e, t, r, n)), (0, h.gO)(o, `${t}`, void 0)),
        (0, h.M6)(o, { synthetic: !0 }),
        o);
  }
  function eS(e, t, r, n) {
    let a = {};
    if (n && r) {
      let n = eb(e, r);
      (n.length && (a.exception = { values: [{ value: t, stacktrace: { frames: n } }] }),
        (0, h.M6)(a, { synthetic: !0 }));
    }
    if ((0, q.NF)(t)) {
      let { __sentry_template_string__: e, __sentry_template_values__: r } = t;
      return ((a.logentry = { message: e, params: r }), a);
    }
    return ((a.message = t), a);
  }
  var eO = r(39619);
  class eT extends ei {
    constructor(e) {
      var t;
      let r =
        ((t = e),
        {
          release:
            "string" == typeof __SENTRY_RELEASE__ ? __SENTRY_RELEASE__ : eO.jf.SENTRY_RELEASE?.id,
          sendClientReports: !0,
          parentSpanIsAlwaysRootSpan: !0,
          ...t,
        });
      (s(r, "browser", ["browser"], eO.jf.SENTRY_SDK_SOURCE || (0, eh.e)()),
        r._metadata?.sdk &&
          (r._metadata.sdk.settings = {
            infer_ip: r.sendDefaultPii ? "auto" : "never",
            ...r._metadata.sdk.settings,
          }),
        super(r));
      let {
          sendDefaultPii: n,
          sendClientReports: a,
          enableLogs: o,
          _experiments: i,
          enableMetrics: l,
        } = this._options,
        u = l ?? i?.enableMetrics ?? !0;
      (eO.jf.document &&
        (a || o || u) &&
        eO.jf.document.addEventListener("visibilitychange", () => {
          "hidden" === eO.jf.document.visibilityState &&
            (a && this._flushOutcomes(), o && M(this), u && k(this));
        }),
        n && this.on("beforeSendSession", e_));
    }
    eventFromException(e, t) {
      return (function (e, t, r, n) {
        let a = eP(e, t, r?.syntheticException || void 0, n);
        return (
          (0, h.M6)(a),
          (a.level = "error"),
          r?.event_id && (a.event_id = r.event_id),
          (0, U.XW)(a)
        );
      })(this._options.stackParser, e, t, this._options.attachStacktrace);
    }
    eventFromMessage(e, t = "info", r) {
      return (function (e, t, r = "info", n, a) {
        let o = eS(e, t, n?.syntheticException || void 0, a);
        return ((o.level = r), n?.event_id && (o.event_id = n.event_id), (0, U.XW)(o));
      })(this._options.stackParser, e, t, r, this._options.attachStacktrace);
    }
    _prepareEvent(e, t, r, n) {
      return ((e.platform = e.platform || "javascript"), super._prepareEvent(e, t, r, n));
    }
  }
  var ew = r(21010);
  function ej() {
    "console" in a.O &&
      o.Ow.forEach(function (e) {
        e in a.O.console &&
          (0, b.GS)(a.O.console, e, function (t) {
            return (
              (o.Z9[e] = t),
              function (...t) {
                (0, ew.aj)("console", { args: t, level: e });
                let r = o.Z9[e];
                r?.apply(a.O.console, t);
              }
            );
          });
      });
  }
  var ex = r(81725),
    eA = r(81611),
    eC = r(60567),
    eM = r(12398);
  function eN(e) {
    if (void 0 !== e) return e >= 400 && e < 500 ? "warning" : e >= 500 ? "error" : void 0;
  }
  var ek = r(69142),
    eI = r(7916),
    eL = r(62234),
    eD = r(79152),
    eU = r(91488);
  let eH =
    "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(
      ",",
    );
  function eF(e) {
    return function (...t) {
      let r = t[0];
      return (
        (t[0] = (0, eO.LV)(r, {
          mechanism: { handled: !1, type: `auto.browser.browserapierrors.${(0, P.qQ)(e)}` },
        })),
        e.apply(this, t)
      );
    };
  }
  function e$(e) {
    return function (t) {
      return e.apply(this, [
        (0, eO.LV)(t, {
          mechanism: {
            data: { handler: (0, P.qQ)(e) },
            handled: !1,
            type: "auto.browser.browserapierrors.requestAnimationFrame",
          },
        }),
      ]);
    };
  }
  function eB(e) {
    return function (...t) {
      let r = this;
      return (
        ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((e) => {
          e in r &&
            "function" == typeof r[e] &&
            (0, b.GS)(r, e, function (t) {
              let r = {
                  mechanism: {
                    data: { handler: (0, P.qQ)(t) },
                    handled: !1,
                    type: `auto.browser.browserapierrors.xhr.${e}`,
                  },
                },
                n = (0, b.sp)(t);
              return (n && (r.mechanism.data.handler = (0, P.qQ)(n)), (0, eO.LV)(t, r));
            });
        }),
        e.apply(this, t)
      );
    };
  }
  var ez = r(54402),
    eq = r(20370);
  function eY(e) {
    eU.T && o.Yz.log(`Global Handler attached: ${e}`);
  }
  function eX() {
    let e = (0, v.KU)();
    return e?.getOptions() || { stackParser: () => [], attachStacktrace: !1 };
  }
  function eW(e) {
    return Array.isArray(e.errors);
  }
  function eK(e, t, r) {
    e.mechanism = {
      handled: !0,
      type: "auto.core.linked_errors",
      ...(eW(r) && { is_exception_group: !0 }),
      ...e.mechanism,
      exception_id: t,
    };
  }
  function eG(e, t, r, n) {
    e.mechanism = {
      handled: !0,
      ...e.mechanism,
      type: "chained",
      source: t,
      exception_id: r,
      parent_id: n,
    };
  }
  function eV(e, t, r, n) {
    let a = { filename: e, function: "<anonymous>" === t ? P.yF : t, in_app: !0 };
    return (void 0 !== r && (a.lineno = r), void 0 !== n && (a.colno = n), a);
  }
  let eJ = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i,
    eQ =
      /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    eZ = /\((\S*)(?::(\d+))(?::(\d+))\)/,
    e0 = /at (.+?) ?\(data:(.+?),/,
    e1 = [
      30,
      (e) => {
        let t = e.match(e0);
        if (t) return { filename: `<data:${t[2]}>`, function: t[1] };
        let r = eJ.exec(e);
        if (r) {
          let [, e, t, n] = r;
          return eV(e, P.yF, +t, +n);
        }
        let n = eQ.exec(e);
        if (n) {
          if (n[2]?.indexOf("eval") === 0) {
            let e = eZ.exec(n[2]);
            e && ((n[2] = e[1]), (n[3] = e[2]), (n[4] = e[3]));
          }
          let [e, t] = e6(n[1] || P.yF, n[2]);
          return eV(t, e, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
        }
      },
    ],
    e2 =
      /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i,
    e3 = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
    e4 = [
      50,
      (e) => {
        let t = e2.exec(e);
        if (t) {
          if (t[3] && t[3].indexOf(" > eval") > -1) {
            let e = e3.exec(t[3]);
            e && ((t[1] = t[1] || "eval"), (t[3] = e[1]), (t[4] = e[2]), (t[5] = ""));
          }
          let e = t[3],
            r = t[1] || P.yF;
          return (([r, e] = e6(r, e)), eV(e, r, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0));
        }
      },
    ],
    e5 = (0, P.gd)(e1, e4),
    e6 = (e, t) => {
      let r = -1 !== e.indexOf("safari-extension"),
        n = -1 !== e.indexOf("safari-web-extension");
      return r || n
        ? [
            -1 !== e.indexOf("@") ? e.split("@")[0] : P.yF,
            r ? `safari-extension:${t}` : `safari-web-extension:${t}`,
          ]
        : [e, t];
    };
  var e7 = r(7755);
  function e8(e, t = (0, e7.qd)("fetch")) {
    let r = 0,
      n = 0;
    async function a(a) {
      let o = a.body.length;
      ((r += o), n++);
      let i = {
        body: a.body,
        method: "POST",
        referrerPolicy: "strict-origin",
        headers: e.headers,
        keepalive: r <= 6e4 && n < 15,
        ...e.fetchOptions,
      };
      try {
        let r = await t(e.url, i);
        return {
          statusCode: r.status,
          headers: {
            "x-sentry-rate-limits": r.headers.get("X-Sentry-Rate-Limits"),
            "retry-after": r.headers.get("Retry-After"),
          },
        };
      } catch (e) {
        throw ((0, e7.y7)("fetch"), e);
      } finally {
        ((r -= o), n--);
      }
    }
    return (function (e, t, r = $(e.bufferSize || 64)) {
      let n = {};
      return {
        send: function (a) {
          let i = [];
          if (
            ((0, C.yH)(a, (t, r) => {
              let a = (0, C.zk)(r);
              (0, B.Jz)(n, a) ? e.recordDroppedEvent("ratelimit_backoff", a) : i.push(t);
            }),
            0 === i.length)
          )
            return Promise.resolve({});
          let s = (0, C.h4)(a[0], i),
            l = (t) => {
              if ((0, C.hP)(s, ["client_report"])) {
                u.T && o.Yz.warn(`Dropping client report. Will not send outcomes (reason: ${t}).`);
                return;
              }
              (0, C.yH)(s, (r, n) => {
                e.recordDroppedEvent(t, (0, C.zk)(n));
              });
            };
          return r
            .add(() =>
              t({ body: (0, C.bN)(s) }).then(
                (e) => (
                  413 === e.statusCode
                    ? (u.T &&
                        o.Yz.error(
                          "Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.",
                        ),
                      l("send_error"))
                    : (u.T &&
                        void 0 !== e.statusCode &&
                        (e.statusCode < 200 || e.statusCode >= 300) &&
                        o.Yz.warn(
                          `Sentry responded with status code ${e.statusCode} to sent event.`,
                        ),
                      (n = (0, B.wq)(n, e))),
                  e
                ),
                (e) => {
                  throw (
                    l("network_error"),
                    u.T && o.Yz.error("Encountered error running transport request:", e),
                    e
                  );
                },
              ),
            )
            .then(
              (e) => e,
              (e) => {
                if (e === F)
                  return (
                    u.T && o.Yz.error("Skipped sending event because buffer is full."),
                    l("queue_overflow"),
                    Promise.resolve({})
                  );
                throw e;
              },
            );
        },
        flush: (e) => r.drain(e),
      };
    })(e, a, $(e.bufferSize || 40));
  }
  function e9(e) {
    let t;
    return [
      ((e = {}) => ({
        ...((e = {}) => {
          let t;
          return {
            name: "EventFilters",
            setup(r) {
              t = g(e, r.getOptions());
            },
            processEvent: (r, n, a) => (
              t || (t = g(e, a.getOptions())),
              !(function (e, t) {
                if (e.type) {
                  if (
                    "transaction" === e.type &&
                    (function (e, t) {
                      if (!t?.length) return !1;
                      let r = e.transaction;
                      return !!r && (0, _.Xr)(r, t);
                    })(e, t.ignoreTransactions)
                  )
                    return (
                      u.T &&
                        o.Yz
                          .warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${(0, h.$X)(e)}`),
                      !0
                    );
                } else {
                  var r, n, a;
                  if (
                    ((r = e), (n = t.ignoreErrors), n?.length && p(r).some((e) => (0, _.Xr)(e, n)))
                  )
                    return (
                      u.T &&
                        o.Yz.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${(0, h.$X)(e)}`),
                      !0
                    );
                  if (
                    ((a = e),
                    a.exception?.values?.length &&
                      !a.message &&
                      !a.exception.values.some(
                        (e) => e.stacktrace || (e.type && "Error" !== e.type) || e.value,
                      ))
                  )
                    return (
                      u.T &&
                        o.Yz
                          .warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${(0, h.$X)(e)}`),
                      !0
                    );
                  if (
                    (function (e, t) {
                      if (!t?.length) return !1;
                      let r = y(e);
                      return !!r && (0, _.Xr)(r, t);
                    })(e, t.denyUrls)
                  )
                    return (
                      u.T &&
                        o.Yz.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${(0, h.$X)(e)}.
Url: ${y(e)}`),
                      !0
                    );
                  if (
                    !(function (e, t) {
                      if (!t?.length) return !0;
                      let r = y(e);
                      return !r || (0, _.Xr)(r, t);
                    })(e, t.allowUrls)
                  )
                    return (
                      u.T &&
                        o.Yz.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${(0, h.$X)(e)}.
Url: ${y(e)}`),
                      !0
                    );
                }
                return !1;
              })(r, t)
                ? r
                : null
            ),
          };
        })(e),
        name: "InboundFilters",
      }))(),
      {
        name: "FunctionToString",
        setupOnce() {
          n = Function.prototype.toString;
          try {
            Function.prototype.toString = function (...e) {
              let t = (0, b.sp)(this),
                r = E.has((0, v.KU)()) && void 0 !== t ? t : this;
              return n.apply(r, e);
            };
          } catch {}
        },
        setup(e) {
          E.set(e, !0);
        },
      },
      {
        name: "ConversationId",
        setup(e) {
          e.on("spanStart", (e) => {
            let t = (0, v.o5)().getScopeData(),
              r = (0, v.rm)().getScopeData(),
              n = t.conversationId || r.conversationId;
            n && e.setAttribute(R.Fy, n);
          });
        },
      },
      ((e = {}) => {
        let t = {
          XMLHttpRequest: !0,
          eventTarget: !0,
          requestAnimationFrame: !0,
          setInterval: !0,
          setTimeout: !0,
          unregisterOriginalCallbacks: !1,
          ...e,
        };
        return {
          name: "BrowserApiErrors",
          setupOnce() {
            (t.setTimeout && (0, b.GS)(eO.jf, "setTimeout", eF),
              t.setInterval && (0, b.GS)(eO.jf, "setInterval", eF),
              t.requestAnimationFrame && (0, b.GS)(eO.jf, "requestAnimationFrame", e$),
              t.XMLHttpRequest &&
                "XMLHttpRequest" in eO.jf &&
                (0, b.GS)(XMLHttpRequest.prototype, "send", eB));
            let e = t.eventTarget;
            e &&
              (Array.isArray(e) ? e : eH).forEach((e) =>
                (function (e, t) {
                  let r = eO.jf,
                    n = r[e]?.prototype;
                  n?.hasOwnProperty?.("addEventListener") &&
                    ((0, b.GS)(n, "addEventListener", function (r) {
                      return function (n, a, o) {
                        var i, s, l, u;
                        try {
                          ((i = a),
                            "function" == typeof i.handleEvent &&
                              (a.handleEvent = (0, eO.LV)(a.handleEvent, {
                                mechanism: {
                                  data: { handler: (0, P.qQ)(a), target: e },
                                  handled: !1,
                                  type: "auto.browser.browserapierrors.handleEvent",
                                },
                              })));
                        } catch {}
                        return (
                          t.unregisterOriginalCallbacks &&
                            ((s = this),
                            (l = n),
                            (u = a),
                            s &&
                              "object" == typeof s &&
                              "removeEventListener" in s &&
                              "function" == typeof s.removeEventListener &&
                              s.removeEventListener(l, u)),
                          r.apply(this, [
                            n,
                            (0, eO.LV)(a, {
                              mechanism: {
                                data: { handler: (0, P.qQ)(a), target: e },
                                handled: !1,
                                type: "auto.browser.browserapierrors.addEventListener",
                              },
                            }),
                            o,
                          ])
                        );
                      };
                    }),
                    (0, b.GS)(n, "removeEventListener", function (e) {
                      return function (t, r, n) {
                        try {
                          let a = r.__sentry_wrapped__;
                          a && e.call(this, t, a, n);
                        } catch {}
                        return e.call(this, t, r, n);
                      };
                    }));
                })(e, t),
              );
          },
        };
      })(),
      ((e = {}) => {
        let t = { console: !0, dom: !0, fetch: !0, history: !0, sentry: !0, xhr: !0, ...e };
        return {
          name: "Breadcrumbs",
          setup(e) {
            var r, n, a, i, s, l, u;
            (t.console &&
              (function (e) {
                let t = "console";
                ((0, ew.s5)(t, e), (0, ew.AS)(t, ej));
              })(
                ((r = e),
                function (e) {
                  if ((0, v.KU)() !== r) return;
                  let t = {
                    category: "console",
                    data: { arguments: e.args, logger: "console" },
                    level: (0, eM.t)(e.level),
                    message: (0, _.gt)(e.args, " "),
                  };
                  if ("assert" === e.level)
                    if (!1 !== e.args[0]) return;
                    else
                      ((t.message = `Assertion failed: ${(0, _.gt)(e.args.slice(1), " ") || "console.assert"}`),
                        (t.data.arguments = e.args.slice(1)));
                  (0, eA.Z)(t, { input: e.args, level: e.level });
                }),
              ),
              t.dom &&
                (0, eI.i)(
                  ((n = e),
                  (a = t.dom),
                  function (e) {
                    let t, r;
                    if ((0, v.KU)() !== n) return;
                    let i = "object" == typeof a ? a.serializeAttribute : void 0,
                      s =
                        "object" == typeof a && "number" == typeof a.maxStringLength
                          ? a.maxStringLength
                          : void 0;
                    (s &&
                      s > 1024 &&
                      (eU.T &&
                        o.Yz.warn(
                          `\`dom.maxStringLength\` cannot exceed 1024, but a value of ${s} was configured. Sentry will use 1024 instead.`,
                        ),
                      (s = 1024)),
                      "string" == typeof i && (i = [i]));
                    try {
                      var l;
                      let n = e.event,
                        a = (l = n) && l.target ? n.target : n;
                      ((t = (0, eC.Hd)(a, { keyAttrs: i, maxStringLength: s })),
                        (r = (0, eC.xE)(a)));
                    } catch {
                      t = "<unknown>";
                    }
                    if (0 === t.length) return;
                    let u = { category: `ui.${e.name}`, message: t };
                    (r && (u.data = { "ui.component_name": r }),
                      (0, eA.Z)(u, { event: e.event, name: e.name, global: e.global }));
                  }),
                ),
              t.xhr &&
                (0, eL.Mn)(
                  ((i = e),
                  function (e) {
                    if ((0, v.KU)() !== i) return;
                    let { startTimestamp: t, endTimestamp: r } = e,
                      n = e.xhr[eL.Er];
                    if (!t || !r || !n) return;
                    let { method: a, url: o, status_code: s, body: l } = n,
                      u = { xhr: e.xhr, input: l, startTimestamp: t, endTimestamp: r },
                      c = {
                        category: "xhr",
                        data: { method: a, url: o, status_code: s },
                        type: "http",
                        level: eN(s),
                      };
                    (i.emit("beforeOutgoingRequestBreadcrumb", c, u), (0, eA.Z)(c, u));
                  }),
                ),
              t.fetch &&
                (0, ex.ur)(
                  ((s = e),
                  function (e) {
                    if ((0, v.KU)() !== s) return;
                    let { startTimestamp: t, endTimestamp: r } = e;
                    if (
                      r &&
                      (!e.fetchData.url.match(/sentry_key/) || "POST" !== e.fetchData.method)
                    )
                      if (e.error) {
                        let n = {
                            data: e.error,
                            input: e.args,
                            startTimestamp: t,
                            endTimestamp: r,
                          },
                          a = {
                            category: "fetch",
                            data: e.fetchData,
                            level: "error",
                            type: "http",
                          };
                        (s.emit("beforeOutgoingRequestBreadcrumb", a, n), (0, eA.Z)(a, n));
                      } else {
                        let n = e.response,
                          a = { ...e.fetchData, status_code: n?.status },
                          o = { input: e.args, response: n, startTimestamp: t, endTimestamp: r },
                          i = {
                            category: "fetch",
                            data: a,
                            type: "http",
                            level: eN(a.status_code),
                          };
                        (s.emit("beforeOutgoingRequestBreadcrumb", i, o), (0, eA.Z)(i, o));
                      }
                  }),
                ),
              t.history &&
                (0, eD._)(
                  ((l = e),
                  function (e) {
                    if ((0, v.KU)() !== l) return;
                    let t = e.from,
                      r = e.to,
                      n = (0, ek.Dl)(eO.jf.location.href),
                      a = t ? (0, ek.Dl)(t) : void 0,
                      o = (0, ek.Dl)(r);
                    (a?.path || (a = n),
                      n.protocol === o.protocol && n.host === o.host && (r = o.relative),
                      n.protocol === a.protocol && n.host === a.host && (t = a.relative),
                      (0, eA.Z)({ category: "navigation", data: { from: t, to: r } }));
                  }),
                ),
              t.sentry &&
                e.on(
                  "beforeSendEvent",
                  ((u = e),
                  function (e) {
                    (0, v.KU)() === u &&
                      (0, eA.Z)(
                        {
                          category: `sentry.${"transaction" === e.type ? "transaction" : "event"}`,
                          event_id: e.event_id,
                          level: e.level,
                          message: (0, h.$X)(e),
                        },
                        { event: e },
                      );
                  }),
                ));
          },
        };
      })(),
      ((e = {}) => {
        let t = { onerror: !0, onunhandledrejection: !0, ...e };
        return {
          name: "GlobalHandlers",
          setupOnce() {
            Error.stackTraceLimit = 50;
          },
          setup(e) {
            var r, n;
            (t.onerror &&
              ((r = e),
              (0, ez.L)((e) => {
                let { stackParser: t, attachStacktrace: n } = eX();
                if ((0, v.KU)() !== r || (0, eO.jN)()) return;
                let { msg: a, url: o, line: i, column: s, error: u } = e,
                  c = (function (e, t, r, n) {
                    let a = (e.exception = e.exception || {}),
                      o = (a.values = a.values || []),
                      i = (o[0] = o[0] || {}),
                      s = (i.stacktrace = i.stacktrace || {}),
                      l = (s.frames = s.frames || []);
                    return (
                      0 === l.length &&
                        l.push({
                          colno: n,
                          lineno: r,
                          filename:
                            (function (e) {
                              if ((0, q.Kg)(e) && 0 !== e.length)
                                return e.startsWith("data:") ? `<${(0, ek.zm)(e, !1)}>` : e;
                            })(t) ?? (0, eC.$N)(),
                          function: P.yF,
                          in_app: !0,
                        }),
                      e
                    );
                  })(eP(t, u || a, void 0, n, !1), o, i, s);
                ((c.level = "error"),
                  (0, l.r)(c, {
                    originalException: u,
                    mechanism: { handled: !1, type: "auto.browser.global_handlers.onerror" },
                  }));
              }),
              eY("onerror")),
              t.onunhandledrejection &&
                ((n = e),
                (0, eq.r)((e) => {
                  var t;
                  let { stackParser: r, attachStacktrace: a } = eX();
                  if ((0, v.KU)() !== n || (0, eO.jN)()) return;
                  let o = (function (e) {
                      if ((0, q.sO)(e)) return e;
                      try {
                        if ("reason" in e) return e.reason;
                        if ("detail" in e && "reason" in e.detail) return e.detail.reason;
                      } catch {}
                      return e;
                    })(e),
                    i = (0, q.sO)(o)
                      ? ((t = o),
                        {
                          exception: {
                            values: [
                              {
                                type: "UnhandledRejection",
                                value: `Non-Error promise rejection captured with value: ${String(t)}`,
                              },
                            ],
                          },
                        })
                      : eP(r, o, void 0, a, !0);
                  ((i.level = "error"),
                    (0, l.r)(i, {
                      originalException: o,
                      mechanism: {
                        handled: !1,
                        type: "auto.browser.global_handlers.onunhandledrejection",
                      },
                    }));
                }),
                eY("onunhandledrejection")));
          },
        };
      })(),
      ((e = {}) => {
        let t = e.limit || 5,
          r = e.key || "cause";
        return {
          name: "LinkedErrors",
          preprocessEvent(e, n, a) {
            !(function (e, t, r, n, a, o) {
              if (!a.exception?.values || !o || !(0, q.tH)(o.originalException, Error)) return;
              let i =
                a.exception.values.length > 0
                  ? a.exception.values[a.exception.values.length - 1]
                  : void 0;
              i &&
                (a.exception.values = (function e(t, r, n, a, o, i, s, l) {
                  if (i.length >= n + 1) return i;
                  let u = [...i];
                  if ((0, q.tH)(a[o], Error)) {
                    eK(s, l, a);
                    let i = t(r, a[o]),
                      c = u.length;
                    (eG(i, o, c, l), (u = e(t, r, n, a[o], o, [i, ...u], i, c)));
                  }
                  return (
                    eW(a) &&
                      a.errors.forEach((i, c) => {
                        if ((0, q.tH)(i, Error)) {
                          eK(s, l, a);
                          let f = t(r, i),
                            d = u.length;
                          (eG(f, `errors[${c}]`, d, l), (u = e(t, r, n, i, o, [f, ...u], f, d)));
                        }
                      }),
                    u
                  );
                })(e, t, n, o.originalException, r, a.exception.values, i, 0));
            })(ey, a.getOptions().stackParser, r, t, e, n);
          },
        };
      })(),
      {
        name: "Dedupe",
        processEvent(e) {
          if (e.type) return e;
          try {
            var r, n;
            if (
              ((r = e),
              (n = t) &&
                ((function (e, t) {
                  let r = e.message,
                    n = t.message;
                  return (
                    (!!r || !!n) &&
                    (!r || !!n) &&
                    (!!r || !n) &&
                    r === n &&
                    !!O(e, t) &&
                    !!S(e, t) &&
                    !0
                  );
                })(r, n) ||
                  (function (e, t) {
                    let r = T(t),
                      n = T(e);
                    return (
                      !!r &&
                      !!n &&
                      r.type === n.type &&
                      r.value === n.value &&
                      !!O(e, t) &&
                      !!S(e, t)
                    );
                  })(r, n)))
            )
              return (
                u.T &&
                  o.Yz.warn("Event dropped due to being a duplicate of previously captured event."),
                null
              );
          } catch {}
          return (t = e);
        },
      },
      {
        name: "HttpContext",
        preprocessEvent(e) {
          if (!eO.jf.navigator && !eO.jf.location && !eO.jf.document) return;
          let t = (0, eO.AP)(),
            r = { ...t.headers, ...e.request?.headers };
          e.request = { ...t, ...e.request, headers: r };
        },
      },
      {
        name: "CultureContext",
        preprocessEvent(e) {
          let t = (function () {
            try {
              let e = eO.jf.Intl;
              if (!e) return;
              let t = e.DateTimeFormat().resolvedOptions();
              return { locale: t.locale, timezone: t.timeZone, calendar: t.calendar };
            } catch {
              return;
            }
          })();
          t && (e.contexts = { ...e.contexts, culture: { ...t, ...e.contexts?.culture } });
        },
      },
      ((e = {}) => {
        let t = e.lifecycle ?? "route";
        return {
          name: "BrowserSession",
          setupOnce() {
            if (void 0 === eO.jf.document) {
              eU.T &&
                o.Yz.warn(
                  "Using the `browserSessionIntegration` in non-browser environments is not supported.",
                );
              return;
            }
            ((0, l.J0)({ ignoreDuration: !0 }), (0, l.J5)());
            let e = (0, v.rm)(),
              r = e.getUser();
            (e.addScopeListener((e) => {
              let t = e.getUser();
              (r?.id !== t?.id || r?.ip_address !== t?.ip_address) && ((0, l.J5)(), (r = t));
            }),
              "route" === t &&
                (0, eD._)(({ from: e, to: t }) => {
                  e !== t && ((0, l.J0)({ ignoreDuration: !0 }), (0, l.J5)());
                }));
          },
        };
      })(),
    ];
  }
  var te = r(12115),
    tt = r(5424),
    tr = r(95704),
    tn = r(47022),
    ta = r(91815),
    to = r(30249),
    ti = r(73360),
    ts = r.n(ti);
  let tl = ts().events ? ts() : ts().default,
    tu = eO.jf,
    tc = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
  function tf(...e) {
    let t = "",
      r = !1;
    for (let n = e.length - 1; n >= -1 && !r; n--) {
      let a = n >= 0 ? e[n] : "/";
      a && ((t = `${a}/${t}`), (r = "/" === a.charAt(0)));
    }
    return (
      (t = (function (e, t) {
        let r = 0;
        for (let t = e.length - 1; t >= 0; t--) {
          let n = e[t];
          "." === n
            ? e.splice(t, 1)
            : ".." === n
              ? (e.splice(t, 1), r++)
              : r && (e.splice(t, 1), r--);
        }
        if (t) for (; r--; ) e.unshift("..");
        return e;
      })(
        t.split("/").filter((e) => !!e),
        !r,
      ).join("/")),
      (r ? "/" : "") + t || "."
    );
  }
  function td(e) {
    let t = 0;
    for (; t < e.length && "" === e[t]; t++);
    let r = e.length - 1;
    for (; r >= 0 && "" === e[r]; r--);
    return t > r ? [] : e.slice(t, r - t + 1);
  }
  class tp {
    constructor(e) {
      ((this._maxSize = e), (this._cache = new Map()));
    }
    get size() {
      return this._cache.size;
    }
    get(e) {
      let t = this._cache.get(e);
      if (void 0 !== t) return (this._cache.delete(e), this._cache.set(e, t), t);
    }
    set(e, t) {
      if (this._cache.size >= this._maxSize) {
        let e = this._cache.keys().next().value;
        this._cache.delete(e);
      }
      this._cache.set(e, t);
    }
    remove(e) {
      let t = this._cache.get(e);
      return (t && this._cache.delete(e), t);
    }
    clear() {
      this._cache.clear();
    }
    keys() {
      return Array.from(this._cache.keys());
    }
    values() {
      let e = [];
      return (this._cache.forEach((t) => e.push(t)), e);
    }
  }
  var th = r(71702);
  let t_ = new tp(100);
  var tm = r(95704);
  let tg = a.O;
  var ty = r(95704);
  let tv = !1,
    tb = a.O;
  function tE(e) {
    (tv &&
      (0, o.pq)(() => {
        console.warn(
          "[@sentry/nextjs] You are calling `Sentry.init()` more than once on the client. This can happen if you have both a `sentry.client.config.ts` and a `instrumentation-client.ts` file with `Sentry.init()` calls. It is recommended to call `Sentry.init()` once in `instrumentation-client.ts`.",
        );
      }),
      (tv = !0),
      !tt.T &&
        e.debug &&
        (0, o.pq)(() => {
          console.warn(
            "[@sentry/nextjs] You have enabled `debug: true`, but Sentry debug logging was removed from your bundle (likely via `withSentryConfig({ disableLogger: true })` / `webpack.treeshake.removeDebugLogging: true`). Set that option to `false` to see Sentry debug output.",
          );
        }),
      ("undefined" == typeof __SENTRY_TRACING__ || __SENTRY_TRACING__) &&
        (function () {
          eO.jf.document &&
            (function (e) {
              let t = (0, th.D)(e) || e,
                r = t_.get(t);
              if (void 0 !== r) return r;
              let n = (0, th.c)();
              if (!n?.isrRoutes || !Array.isArray(n.isrRoutes) || 0 === n.isrRoutes.length)
                return (t_.set(t, !1), !1);
              let a = n.isrRoutes.includes(t);
              return (t_.set(t, a), a);
            })(eO.jf.location.pathname) &&
            (e("sentry-trace"), e("baggage"));
          function e(e) {
            try {
              let t = eO.jf.document.querySelector(`meta[name="${e}"]`);
              t && t.remove();
            } catch {}
          }
        })());
    let t = {
      environment:
        e.environment ||
        ty.env.SENTRY_ENVIRONMENT ||
        (function (e) {
          let t = e ? "production" : tr.env.VERCEL_ENV;
          return t ? `vercel-${t}` : void 0;
        })(!0) ||
        "production",
      defaultIntegrations: (function (e) {
        let t = e9(e);
        ("undefined" == typeof __SENTRY_TRACING__ || __SENTRY_TRACING__) &&
          t.push(
            (function (e = {}) {
              let t = (0, tn.dp)({
                  ...e,
                  instrumentNavigation: !1,
                  instrumentPageLoad: !1,
                  onRequestSpanStart(...t) {
                    let [r, { headers: n }] = t;
                    return (
                      n?.get("next-router-prefetch") &&
                        r?.setAttribute("http.request.prefetch", !0),
                      e.onRequestSpanStart?.(...t)
                    );
                  },
                }),
                { instrumentPageLoad: r = !0, instrumentNavigation: n = !0 } = e;
              return {
                ...t,
                afterAllSetup(e) {
                  (n &&
                    (function (e) {
                      if (eO.jf.document.getElementById("__NEXT_DATA__"))
                        tl.events.on("routeChangeStart", (t) => {
                          let r,
                            n,
                            a = (0, ek.f)(t),
                            o = (function (e) {
                              let t = tu.__BUILD_MANIFEST?.sortedPages;
                              if (t)
                                return t.find((t) => {
                                  let r = (function (e) {
                                    let t = e.split("/"),
                                      r = "";
                                    t[t.length - 1]?.match(/^\[\[\.\.\..+\]\]$/) &&
                                      (t.pop(), (r = "(?:/(.+?))?"));
                                    let n = t
                                      .map((e) =>
                                        e
                                          .replace(/^\[\.\.\..+\]$/, "(.+?)")
                                          .replace(/^\[.*\]$/, "([^/]+?)"),
                                      )
                                      .join("/");
                                    return RegExp(`^${n}${r}(?:/)?$`);
                                  })(t);
                                  return e.match(r);
                                });
                            })(a);
                          (o ? ((r = o), (n = "route")) : ((r = a), (n = "url")),
                            (0, tn.Nt)(e, {
                              name: r,
                              attributes: {
                                [R.uT]: "navigation",
                                [R.JD]: "auto.navigation.nextjs.pages_router_instrumentation",
                                [R.i_]: n,
                              },
                            }));
                        });
                      else (0, ta.q3)(e);
                    })(e),
                    t.afterAllSetup(e),
                    r &&
                      (function (e) {
                        if (eO.jf.document.getElementById("__NEXT_DATA__")) {
                          let {
                              route: t,
                              params: r,
                              sentryTrace: n,
                              baggage: a,
                            } = (function () {
                              let e,
                                t = tu.document.getElementById("__NEXT_DATA__");
                              if (t?.innerHTML)
                                try {
                                  e = JSON.parse(t.innerHTML);
                                } catch {
                                  tt.T && o.Yz.warn("Could not extract __NEXT_DATA__");
                                }
                              if (!e) return {};
                              let r = {},
                                { page: n, query: a, props: i } = e;
                              return (
                                (r.route = n),
                                (r.params = a),
                                i?.pageProps &&
                                  ((r.sentryTrace = i.pageProps._sentryTraceData),
                                  (r.baggage = i.pageProps._sentryBaggage)),
                                r
                              );
                            })(),
                            i = (0, to.D0)(a),
                            s = t || tu.location.pathname;
                          i?.["sentry-transaction"] &&
                            "/_error" === s &&
                            (s = (s = i["sentry-transaction"]).replace(
                              /^(GET|POST|PUT|DELETE|PATCH|HEAD|OPTIONS|TRACE|CONNECT)\s+/i,
                              "",
                            ));
                          let l = (0, z.k3)();
                          (0, tn.Sx)(
                            e,
                            {
                              name: s,
                              startTime: l ? l / 1e3 : void 0,
                              attributes: {
                                [R.uT]: "pageload",
                                [R.JD]: "auto.pageload.nextjs.pages_router_instrumentation",
                                [R.i_]: t ? "route" : "url",
                                ...(r && e.getOptions().sendDefaultPii && { ...r }),
                              },
                            },
                            { sentryTrace: n, baggage: a },
                          );
                        } else (0, ta.jw)(e);
                      })(e));
                },
              };
            })(),
          );
        let r = tb._sentryRewriteFramesAssetPrefixPath || "",
          n = ty.env._sentryAssetPrefix || tb._sentryAssetPrefix,
          i = ty.env._sentryBasePath || tb._sentryBasePath,
          s =
            "true" === ty.env._experimentalThirdPartyOriginStackFrames ||
            "true" === tb._experimentalThirdPartyOriginStackFrames;
        return (
          t.push(
            (({
              assetPrefix: e,
              basePath: t,
              rewriteFramesAssetPrefixPath: r,
              experimentalThirdPartyOriginStackFrames: n,
            }) => ({
              ...((e = {}) => {
                let t = e.root,
                  r = e.prefix || "app:///",
                  n = "window" in a.O && !!a.O.window,
                  o =
                    e.iteratee ||
                    (function ({ isBrowser: e, root: t, prefix: r }) {
                      return (n) => {
                        if (!n.filename) return n;
                        let a =
                            /^[a-zA-Z]:\\/.test(n.filename) ||
                            (n.filename.includes("\\") && !n.filename.includes("/")),
                          o = /^\//.test(n.filename);
                        if (e) {
                          if (t) {
                            let e = n.filename;
                            0 === e.indexOf(t) && (n.filename = e.replace(t, r));
                          }
                        } else if (a || o) {
                          let e = a
                              ? n.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/")
                              : n.filename,
                            o = t
                              ? (function (e, t) {
                                  ((e = tf(e).slice(1)), (t = tf(t).slice(1)));
                                  let r = td(e.split("/")),
                                    n = td(t.split("/")),
                                    a = Math.min(r.length, n.length),
                                    o = a;
                                  for (let e = 0; e < a; e++)
                                    if (r[e] !== n[e]) {
                                      o = e;
                                      break;
                                    }
                                  let i = [];
                                  for (let e = o; e < r.length; e++) i.push("..");
                                  return (i = i.concat(n.slice(o))).join("/");
                                })(t, e)
                              : (function (e) {
                                  let t = e.length > 1024 ? `<truncated>${e.slice(-1024)}` : e,
                                    r = tc.exec(t);
                                  return r ? r.slice(1) : [];
                                })(e)[2] || "";
                          n.filename = `${r}${o}`;
                        }
                        return n;
                      };
                    })({ isBrowser: n, root: t, prefix: r });
                return {
                  name: "RewriteFrames",
                  processEvent(e) {
                    let t = e;
                    return (
                      e.exception &&
                        Array.isArray(e.exception.values) &&
                        (t = (function (e) {
                          try {
                            return {
                              ...e,
                              exception: {
                                ...e.exception,
                                values: e.exception.values.map((e) => {
                                  var t;
                                  return {
                                    ...e,
                                    ...(e.stacktrace && {
                                      stacktrace: {
                                        ...(t = e.stacktrace),
                                        frames: t?.frames?.map((e) => o(e)),
                                      },
                                    }),
                                  };
                                }),
                              },
                            };
                          } catch {
                            return e;
                          }
                        })(t)),
                      t
                    );
                  },
                };
              })({
                iteratee: (a) => {
                  if (n) {
                    let r =
                      "undefined" != typeof window && window.location ? window.location.origin : "";
                    if (a.filename?.startsWith(r) && !a.filename.endsWith(".js")) return a;
                    if (e)
                      a.filename?.startsWith(e) && (a.filename = a.filename.replace(e, "app://"));
                    else if (t)
                      try {
                        let { origin: e } = new URL(a.filename);
                        e === r && (a.filename = a.filename?.replace(e, "app://").replace(t, ""));
                      } catch {}
                  } else
                    try {
                      let { origin: e } = new URL(a.filename);
                      a.filename = a.filename?.replace(e, "app://").replace(r, "");
                    } catch {}
                  return (
                    n
                      ? (a.filename?.includes("/_next") && (a.filename = decodeURI(a.filename)),
                        a.filename?.match(
                          /\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
                        ) && (a.in_app = !1))
                      : (a.filename?.startsWith("app:///_next") &&
                          (a.filename = decodeURI(a.filename)),
                        a.filename?.match(
                          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
                        ) && (a.in_app = !1)),
                    a
                  );
                },
              }),
              name: "NextjsClientStackFrameNormalization",
            }))({
              assetPrefix: n,
              basePath: i,
              rewriteFramesAssetPrefixPath: r,
              experimentalThirdPartyOriginStackFrames: s,
            }),
          ),
          t
        );
      })(e),
      release: "9d46c9a45a26a0fc2299a28bea5b70ae4e2f7a1e",
      ...e,
    };
    (!(function (e) {
      let t = tm.env._sentryRewritesTunnelPath || tg._sentryRewritesTunnelPath;
      if (t && e.dsn) {
        let r = (0, A.hH)(e.dsn);
        if (!r) return;
        let n = r.host.match(/^o(\d+)\.ingest(?:\.([a-z]{2}))?\.sentry\.io$/);
        if (n) {
          let a = n[1],
            i = n[2],
            s = `${t}?o=${a}&p=${r.projectId}`;
          (i && (s += `&r=${i}`), (e.tunnel = s), tt.T && o.Yz.log(`Tunneling events to "${s}"`));
        } else tt.T && o.Yz.warn("Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.");
      }
    })(t),
      s(t, "nextjs", ["nextjs", "react"]));
    let r = (function (e) {
        let t = { ...e };
        return (
          s(t, "react"),
          (0, l.o)("react", { version: te.version }),
          (function (e = {}) {
            var t;
            let r =
                !e.skipBrowserExtensionCheck &&
                !!(function () {
                  if (void 0 === eO.jf.window) return !1;
                  let e = eO.jf;
                  if (e.nw) return !1;
                  let t = e.chrome || e.browser;
                  if (!t?.runtime?.id) return !1;
                  let r = (0, eC.$N)();
                  return !(
                    eO.jf === eO.jf.top &&
                    /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(
                      r,
                    )
                  );
                })() &&
                (eU.T &&
                  (0, o.pq)(() => {
                    console.error(
                      "[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/",
                    );
                  }),
                !0),
              n = null == e.defaultIntegrations ? e9() : e.defaultIntegrations,
              a = {
                ...e,
                enabled: !r && e.enabled,
                stackParser: (0, P.vk)(e.stackParser || e5),
                integrations: (function (e) {
                  let t,
                    r = e.defaultIntegrations || [],
                    n = e.integrations;
                  if (
                    (r.forEach((e) => {
                      e.isDefaultInstance = !0;
                    }),
                    Array.isArray(n))
                  )
                    t = [...r, ...n];
                  else if ("function" == typeof n) {
                    let e = n(r);
                    t = Array.isArray(e) ? e : [e];
                  } else t = r;
                  let a = {};
                  return (
                    t.forEach((e) => {
                      let { name: t } = e,
                        r = a[t];
                      (r && !r.isDefaultInstance && e.isDefaultInstance) || (a[t] = e);
                    }),
                    Object.values(a)
                  );
                })({ integrations: e.integrations, defaultIntegrations: n }),
                transport: e.transport || e8,
              };
            (!0 === a.debug &&
              (u.T
                ? o.Yz.enable()
                : (0, o.pq)(() => {
                    console.warn(
                      "[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.",
                    );
                  })),
              (0, v.o5)().update(a.initialScope));
            let i = new eT(a);
            return ((t = i), (0, v.o5)().setClient(t), i.init(), i);
          })(t)
        );
      })(t),
      n = (e) => ("transaction" === e.type && "/404" === e.transaction ? null : e);
    ((n.id = "NextClient404Filter"), (0, l.SA)(n));
    let i = (e) => ("transaction" === e.type && e.transaction === ta.NI ? null : e);
    ((i.id = "IncompleteTransactionFilter"), (0, l.SA)(i));
    let c = (e, t) => {
      var r, n, a, o;
      return ((o = null == t ? void 0 : t.originalException),
      ((0, q.bJ)(o) && "string" == typeof o.digest && o.digest.startsWith("NEXT_REDIRECT;")) ||
        (null == (a = e.exception) || null == (n = a.values) || null == (r = n[0])
          ? void 0
          : r.value) === "NEXT_REDIRECT")
        ? null
        : e;
    };
    return ((c.id = "NextRedirectErrorFilter"), (0, l.SA)(c), r);
  }
}
